var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 30H23.8463C23.8 31.2381 22.9269 32 21.8 32H18C16.8319 32 15.9362 30.9081 15.9519 30H1C0.45 30 0 30.45 0 31V32C0 34.2 1.8 36 4 36H36C38.2 36 40 34.2 40 32V31C40 30.45 39.55 30 39 30ZM36 7C36 5.35 34.65 4 33 4H7C5.35 4 4 5.35 4 7V28H36V7ZM32 24H8V8H32V24Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.c3e51df918985236859579ae7fec70fa.svg";
export { ForwardRef as ReactComponent };